const setTooltipAttributes = (el, binding) => {
  const text = typeof binding.value === 'string' ? binding.value.trim() : ''

  if (!text) {
    el.classList.remove('bb-v-tooltip')
    el.removeAttribute('data-bb-tooltip')
    el.removeAttribute('data-bb-tooltip-position')
    el.removeAttribute('aria-label')
    return
  }

  el.classList.add('bb-v-tooltip')
  el.setAttribute('data-bb-tooltip', text)
  el.setAttribute('data-bb-tooltip-position', binding.arg || 'top')
  el.setAttribute('aria-label', text)
}

export default {
  mounted(el, binding) {
    setTooltipAttributes(el, binding)
  },
  updated(el, binding) {
    setTooltipAttributes(el, binding)
  },
  unmounted(el) {
    el.classList.remove('bb-v-tooltip')
    el.removeAttribute('data-bb-tooltip')
    el.removeAttribute('data-bb-tooltip-position')
    el.removeAttribute('aria-label')
  },
}
